import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminTournamentService {
  constructor() {
    this.endpoints = createPrefix('/admin/tournaments', {
      resolveBinaryBet: '/match/bet/binary',
      tournamentsSearch: '/search',
      tournament: '/',
      match: '/match',
    })
  }

  static create() {
    return new AdminTournamentService()
  }

  async tournamentsSearch(params) {
    const servicePath = this.endpoints.tournamentsSearch()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async addTournament(params) {
    const servicePath = this.endpoints()
    const { data } = await axios.post(servicePath, {
      tournamentName: params.tournamentName,
      sportType: params.sportType,
      startTime: params.startTime,
      endTime: params.endTime,
      jurisdictionId: params.jurisdictionId,
      country: params.country,
      city: params.city,
      venue: params.venue,
      website: params.website,
      logo: params.logo,
      tournamentType: params.tournamentType,
      tournamentFullName: params.tournamentFullName,
      marketingPromotion: params.marketingPromotion,
    })
    return data
  }

  async getTournamentById(id) {
    const servicePath = this.endpoints.tournament()
    const { data } = await axios.get(servicePath + id)
    return data
  }

  async updateTournamentById(params) {
    const servicePath = this.endpoints.tournament()
    const { data } = await axios.put(servicePath + params.id, {
      tournamentName: params.tournamentName,
      sportType: params.sportType,
      startTime: params.startTime,
      endTime: params.endTime,
      country: params.country,
      city: params.city,
      venue: params.venue,
      website: params.website,
      logo: params.logo,
      tournamentType: params.tournamentType,
      tournamentFullName: params.tournamentFullName,
      marketingPromotion: params.marketingPromotion,
    })
    return data
  }

  async resolveBinaryBet(eventId, binaryWinner) {
    const servicePath = this.endpoints.resolveBinaryBet()
    const { data } = await axios.post(servicePath, {
      binaryWinner,
      matchId: eventId,
    })
    return data
  }

  async inwinnableMatch(matchId, status) {
    const servicePath = this.endpoints.match()
    const path = `${servicePath}/${matchId}/inwinnable?inwinnable=${status}`
    const { data } = await axios.put(path, {})
    return data
  }
}
